module.exports = __webpack_public_path__ + "assets/src/style/img/svg/logo-here-now-drenthe-black.svg?798a058941321bb31449488691c8b2a7";